import { gql, useQuery } from "@apollo/client";
import React, { useState, useEffect } from "react";
import ReactLoading from "react-loading";

import { useParams } from "react-router-dom";

import { InvalidUrlError, QuoteExpiredError, NewSessionAvailable } from "../../components/Error";

import Wizard from "./Wizard";

const SESSION_QUERY = gql`
  query InsuranceApplicationSession($iaSession: String) {
    insuranceApplicationSession(iaSession: $iaSession) {
      expired
      isEligible
      isEsignatureComplete
      embeddedSigningUrl
      esignDocumentHash
      esignProvider
      currentStep
      successUrl
      cancelUrl
      isGeneralOptIn
      generalOptInWorkState
      organizationName
      job {
        id
        name
        withholdPremium
        address {
          region
        }
      }
      contractor {
        unredactedDict
        firstName
        lastName
        companyName
        hasBusinessEntity
        withholdPremium
        withholdPremiumOrgOverride
        address {
          line1
          line2
          line3
          locality
          region
          postalcode
        }
        paymentClientToken
        paymentMethod
        paymentMethodUnusable
      }
      quotes {
        edges {
          node {
            id
            effectiveDate
            netRate
            isGlWcAndMedia
            isGlAndMedia
            isWcAndMedia
            isGlAndWc
            isGlOnly
            isWcOnly
            premiumAmountOwed
            job {
              name
              entity {
                name
              }
              wage
            }
            tenant {
              organization {
                publicId
                name
              }
            }
          }
        }
      }
      policies {
        edges {
          node {
            id
            pdfUrl
          }
        }
      }
    }
  }
`;

const ActiveApplication = (props) => {
  const { iaSession } = props;
  const { loading, data, error } = useQuery(SESSION_QUERY, {
    variables: { iaSession },
  });

  if (loading) {
    return (
      <div className="vh-100 dt w-100">
        <div className="dtc v-mid tc white ph3 ph4-l">
          <ReactLoading type={"spin"} color={"#cccccc"} className="center" />
        </div>
      </div>
    );
  }

  if (error) {
    console.log('GraphQL Error:', error);
    // First check for session expiration with new session URL
    if (error.graphQLErrors?.[0]?.extensions?.status === "SESSION_EXPIRED" && 
        error.graphQLErrors?.[0]?.extensions?.new_session_url) {
      return <NewSessionAvailable newSessionUrl={error.graphQLErrors[0].extensions.new_session_url} />;
    }
    // Then check for quote expiration
    if (error.message?.includes("quote end date has passed")) {
      return <QuoteExpiredError />;
    }
    // Fall back to invalid URL error
    return <InvalidUrlError />;
  }

  if (data) {
    if (data?.insuranceApplicationSession?.expired) {
      return <QuoteExpiredError />;
    } else {
      return <Wizard data={data} {...props} iaSession={iaSession} />;
    }
  }

  return <InvalidUrlError />;
};

function InsuranceApplication(props) {
  const { iaSession } = useParams();
  return <ActiveApplication {...props} iaSession={iaSession} />;
}

export default InsuranceApplication;
